import { Component } from '@angular/core';
import { LoaderService } from '../shared/services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
  readonly loaderText$;
  readonly isloaderVisible$;

  constructor(loaderService: LoaderService) {
    this.loaderText$ = loaderService.loaderText$;
    this.isloaderVisible$ = loaderService.isLoaderVisible$;
  }

}
